import { getContractApiUrl } from './apiUrls';
import { authAudienceConfigured, portalApiTokenOptions } from './authSession';

const BACKEND_URL = getContractApiUrl();

export async function trackFormWizardEvent(getAccessTokenSilently, payload) {
  const headers = { 'Content-Type': 'application/json' };
  if (authAudienceConfigured() && getAccessTokenSilently) {
    const token = await getAccessTokenSilently(portalApiTokenOptions());
    if (typeof token === 'string' && token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }
  await fetch(`${BACKEND_URL}/events/track`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
}

export function formWizardEventPayload({
  phase,
  formType,
  userEmail,
  userName,
  metadata = {},
}) {
  const isPurchaseAgreement = formType === 'purchase_agreement' || !formType;
  return {
    event_type: isPurchaseAgreement
      ? `contract_creation_${phase}`
      : `form_creation_${phase}`,
    user_email: userEmail,
    user_name: userName || '',
    metadata: {
      form_type: formType || 'purchase_agreement',
      ...metadata,
    },
  };
}
